import { Map } from 'immutable';

//didn't declare module since it may break other usage of the `get`.
// eslint-disable-next-line
export interface ImmutableMap<V> extends Omit<Map<string, any>, 'get'> {
  get<K extends keyof V>(name: K): V[K];
}

export function TypedMap<V>(value: V): ImmutableMap<V> {
  return Map(value) as ImmutableMap<V>;
}
